// extracted by mini-css-extract-plugin
export default {"root":"Notification_root__Wubxo","dot":"Notification_dot__uzG8s"};